var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgItLang = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#it-lang_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#it-lang_svg__b)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1 1h18v14H-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009246",
  d: "M-1 1h6v14h-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CE2B37",
  d: "M11.001 1H17v14h-5.999z"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 7.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "it-lang_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  x: 1,
  y: 1,
  fill: "#fff",
  rx: 7
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "it-lang_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1 1h18v14H-1z"
})))));
export default SvgItLang;